/**
 * Used to determine where database records live.
 *
 * Long term, this enum should be removed,
 *
 * Everything we care about will eventually end up in regional api for data sovereignty.
 *
 * This exists as part of a migration strategy as we move towards regionalising everything.
 */
export var DataStore;
(function (DataStore) {
    /**
     * Per Region Databases
     */
    DataStore["Regional"] = "regional";
    /**
     * Our centralised "Core Database"
     */
    DataStore["Core"] = "core";
})(DataStore || (DataStore = {}));
